import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL || '/mlapi';

export const ChatBrandingService = {
    getForWorkflow: async (workflowId) => {
        const { data } = await axios.get(`${BASE}/chat/branding/${workflowId}`);
        return data;
    },
    assetUrl: (path) => (path ? `${BASE}/${path}` : null),
};
